import { render, staticRenderFns } from "./ContabilitaDocumentiListComponent.vue?vue&type=template&id=8bd9d1ae"
import script from "./ContabilitaDocumentiListComponent.vue?vue&type=script&lang=js"
export * from "./ContabilitaDocumentiListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports